import axiosInstanceAuth, { httpHeader } from "@components/axiosInstances";
import { MenuModule } from "@components/axiosInstances/types/menu-access";

import { buildUrlParams } from "utils/params";

export const URL_PAGE_SETTING = {
    GET_WHITELIST_IP: '/api/auth/page-setting/imune-ip',
    GET_PAGE_SETTING: '/api/auth/page-setting/by-name',
    TOGGLE_PAGE_SETTING: '/api/page-setting/toggle-is-active',
}

const GET_PAGE_SETTING = async (name: string) => {
    try {
        const url = URL_PAGE_SETTING.GET_PAGE_SETTING;
        const response = await axiosInstanceAuth.get(`${url}?page_name=${name}`);
        return response.data.data;
    } catch (error) {
        throw error
    }
}
const UPDATE_IS_ACTIVE_PAGE_SETTING = async (token: string, name: string) => {
    try {
        const url = URL_PAGE_SETTING.TOGGLE_PAGE_SETTING;
        const response = await axiosInstanceAuth.put(url, { name }, httpHeader(token));
        return response.data.data
    } catch (error) {
        throw error
    }
}

const GET_WHITELIST_IP = async () => {
    try {
        const url = URL_PAGE_SETTING.GET_WHITELIST_IP;
        const response = await axiosInstanceAuth.get(`${url}`);
        return response.data.data;
    } catch (error) {
        throw error
    }
}




const PAGE_SETTING_API = {
    GET_PAGE_SETTING,
    UPDATE_IS_ACTIVE_PAGE_SETTING,
    GET_WHITELIST_IP
}
export default PAGE_SETTING_API